import { CommonError } from '../../../types';
import { NewsActions } from './actions';
import { FETCH_NEWS_FAILURE, FETCH_NEWS_REQUEST, FETCH_NEWS_SUCCESS } from './constants';
import { NewsData } from './types';

export interface NewsState {
    newsData: NewsData[];

    loading: boolean;
    error: CommonError | null;
}
const initialState: NewsState = {
    newsData: [],
    loading: false,
    error: null,
};
export const StockNewsReducer = (state = initialState, action: NewsActions): NewsState => {
    switch (action.type) {
        case FETCH_NEWS_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_NEWS_SUCCESS: {
            return { ...state, loading: false, newsData: action.payload };
        }
        case FETCH_NEWS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
